<template>
    <Dialog
        :is-popup="isOpen"
        @close="close"
        :scrollable="false"
    >
        <div class="task-update-popup">
            <h1>
                Задача
            </h1>
            <div class="form">
                <ModelString
                    class="name"
                    label="Заголовок"
                    v-model="item.name"
                    @change="setUpdate('name', $event)"
                    :valid="validation.name.valid"
                ></ModelString>
                <ModelTextArea
                    class="description"
                    label="Описание"
                    v-model="item.description"
                    @change="setUpdate('description', $event)"
                    :valid="validation.description.valid"
                />
                <ModelISO
                    class="deadline"
                    label="Срок выполнениея"
                    v-model="item.deadline"
                    @change="setUpdate('deadline', $event)"
                    :valid="validation.deadline.valid"
                />
            </div>
            <div class="buttons">
                <Button
                    class="btn"
                    outline
                    @click="save"
                >Сохранить</Button>
            </div>
        </div>
    </Dialog>
</template>

<script>
import Dialog from '../../../../UI/Dialog';
import Button from '../../../../UI/Button';
import ModelString from '../../../../UI/models/ModelString';
import ModelTextArea from '../../../../UI/models/ModelTextArea';
import ModelISO from '../../../../UI/models/ModelISO';
import {validation} from '../../../../../tools/comparer';
import {mapActions} from 'vuex';

const actions = [
    'updateTask',
];

export default {
    name: 'TaskUpdate',
    props: {
        task: {
            type: Object,
            required: false,
        },
    },
    data: () => ({
        item: {},
        validation: {
            name: {
                reg: "empty",
                valid: true,
            },
            description: {
                reg: "empty",
                valid: true,
            },
            deadline: {
                reg: "date",
                valid: true,
            },
        },
        updates: {},
    }),
    computed: {
        isOpen: {
            get() {
                return this.task !== null;
            },
            set() {
                this.close();
            },
        },
    },
    components: {
        Dialog,
        Button,
        ModelString,
        ModelTextArea,
        ModelISO,
    },
    watch: {
        task(v) {
            this.updateItem();
        },
    },
    mounted() {
        this.updateItem();
    },
    methods: {
        ...mapActions('mentoring/tasks', actions),
        setDefaults() {
            this.item = {
                name: '',
                description: '',
                deadline: null,
            };
        },
        updateItem() {
            if (this.task !== null) {
                this.item = {
                    ...this.task,
                    deadline: this.task.deadline.toISOString(),
                };
            } else {
                this.setDefaults();
            }
        },
        setUpdate(key, value) {
            this.$set(this.updates, key, value);
            this.validation[key].valid = true;
        },
        async save() {
            Object.keys(this.validation).forEach((key) => {
                this.validation[key].valid = true;
            });
            let errors = validation(this.item, this.validation);
            if (errors.length > 0) {
                errors.forEach(key => {
                    this.validation[key].valid = false;
                });
            } else {
                await this.updateTask({
                    ...this.updates,
                    task_id: this.item.id,
                });
                this.close();
            }
        },
        close() {
            this.$emit('change', null);
        },
    },
    model: {
        prop: 'task',
        event: 'change',
    },
};
</script>

<style lang="scss">
    @import '../../../../../styles/rem';

    .task-update-popup {
        h1 {
            font-style: normal;
            font-size: rem(24);
            line-height: rem(32);
            text-align: left;
            color: #2A2626;
            margin-top: 0;

            @include on-mobile {
                font-size: mrem(24);
                line-height: mrem(32);
            }
        }
        p {
            font-size: rem(18);
            line-height: rem(26);
            text-align: center;
            color: #2A2626;

            @include on-mobile {
                font-size: mrem(18);
                line-height: mrem(26);
            }
        }
        .btn {
            width: 100%;

            @include on-mobile {
                background: #4663AB;
                color: white;
                border-radius: mrem(4);
            }
        }
        .buttons {
            display: flex;
            flex-direction: row;
            justify-content: space-around;

            @include on-mobile {
                flex-wrap: wrap;
                flex-direction: column-reverse;
            }
        }



        .name {
            margin-bottom: rem(40);
            @include on-mobile {
                margin-bottom: mrem(40);
            }
        }
        .description {
            margin-bottom: rem(24);
            @include on-mobile {
                margin-bottom: mrem(24);
            }
        }
        .deadline {
            margin-bottom: rem(24);
            @include on-mobile {
                margin-bottom: mrem(24);
            }
        }
    }
</style>

<style lang="scss" scoped>

</style>